import { CLOSE_QUERY_INFO } from 'action-types';

export default function () {
  return {
    type: CLOSE_QUERY_INFO,
  };
}
